import { createAsyncThunk } from '@reduxjs/toolkit';
import { Json } from '@gift/types/Json';
import { updateStatus } from '../slices/fontsSlice';
import { urls } from '@gift/common/_urls';
import { reportError } from '@gift/common/helpers/logging';

export const loadFont = createAsyncThunk(
    'fonts/loadFont',
    async (font: Json.Font, thunkApi) => {
        const fontFace = new FontFace(font.name, `url(${urls.loadPublicAsset(font.id, 'en-US')})`);
        try {
            await fontFace.load();
            document.fonts.add(fontFace);
            thunkApi.dispatch(updateStatus({ name: font.name, status: 'ready' }));
        } catch (e) {
            reportError(e);
            thunkApi.dispatch(updateStatus({ name: font.name, status: 'error' }));
        }
    });